import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// reducers
import rootReducer from './rootReducer';

// actions
export * from './actions';

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
};

const configureAppStore = () => {
  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const enhancers = [];

  const store = configureStore({
    reducer: persistedReducer,
    enhancers,
    middleware: getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  });

  const persistor = persistStore(store);

  return { store, persistor };
};

export default configureAppStore;
